<script>
  export let id = 'checkBox';
  export let checked = false;
  export let label = '';
  export let bootstrap3 = false;
  export let disabled = false;
  export let tooltip = ""
</script>

{#if bootstrap3}
  <label for={id} class="bootstrap3">
    {label}
    <input {id} type="checkbox" bind:checked class="bootstrap3" />
  </label>
{:else}
  <span class="d-flex align-items-center">
    <label class="m-0" for={id}>{label}</label>
    <span title={tooltip}
      ><input {id} type="checkbox" bind:checked {disabled} /></span
    >
  </span>
{/if}

<style>
  input {
    height: 32px;
    width: 32px;
    margin-left: 15px;
  }

  input.bootstrap3 {
    position: absolute;
    margin-left: 20px !important;
    margin-top: -8px !important;
  }

  label.bootstrap3 {
    padding-left: 0 !important;
    font-weight: bold;
  }
</style>
